import { render } from "./Credits.vue?vue&type=template&id=4a53a2a2&scoped=true"
import script from "./Credits.vue?vue&type=script&lang=js"
export * from "./Credits.vue?vue&type=script&lang=js"

import "./Credits.vue?vue&type=style&index=0&id=4a53a2a2&scoped=true&lang=scss"
import "./Credits.vue?vue&type=style&index=1&id=4a53a2a2&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a53a2a2"]])

export default __exports__